import React, { Component } from 'react';
import DualListBox from 'react-dual-listbox';
import { CardBody, Card, Label, Col, Button, Row, Input } from 'reactstrap'
import { connect } from 'react-redux';
import './style.scss';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import Select from 'react-select';
import { getCorporateName } from '../../../Analyst/Cases/List/Actions';
import { PLATFORMS, PLATFORM_RUBIX_KYC } from '../../../Analyst/Cases/constants';
// import { Preloading } from 'components/UI/Preloader/action';
import {
    fetchApiAccessesInfo, fetchApiAccessTypes,
    submitApiAccesses
} from '../action';
import {
    displayErrorMessage, displaySuccessMessage,
} from '../../../Corporate/my-portfolio/monitoring/charts/monitoring-util'
import { getFormInitialValues } from 'redux-form';

class ApiAccessManager extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialStates();
    }

    getInitialStates() {
        return {
                availableApis: [],
                allowedApis: [],
                corporates: [],
                accessTypes: [],
                selectedCorporate: null,
                selectedAccessType: null,
                selectedPlatform: null
                }
    }
    
    resetStates() {
        this.setState(this.getInitialStates());
    }

    resetDualListBox() {
        if(this.state.availableApis.length != 0 || this.state.allowedApis.length != 0)
        this.setState({
            availableApis: [],
            allowedApis: [],
        })
    }

    resetAccessType() {
        if(this.state.selectedAccessType)
            this.setState({ selectedAccessType: null });
    }

    componentDidMount() {
        this.props.getCorporateName();
    }

    componentDidUpdate(prevProps) {

        if (prevProps.corporateNameList !== this.props.corporateNameList) {
            let corporateNames = [];
            this.props.corporateNameList.forEach(item => {
                corporateNames.push({ value: item.id, label: item.name })
            })
            this.setState({
                corporates: corporateNames,
            });
        }

        //for fetching api info success response
        if (prevProps.apiAccessesInfoData !== this.props.apiAccessesInfoData && !this.props.apiAccessesInfoData.error) {
            if(this.props.apiAccessesInfoData.availableApis && this.props.apiAccessesInfoData.allowedAccesses) {
                let availableApis = [];

                this.props.apiAccessesInfoData.availableApis.forEach(item => {
                    availableApis.push({ value: item, label: item });
                });

                this.props.apiAccessesInfoData.allowedAccesses.forEach(item => {
                    availableApis.push({ value: item, label: item });
                });

                this.setState({
                    availableApis: availableApis
                }, ()=> {   //shifting and selecting all allowed apis dynamically from available apis listbox to selected listbox
                    this.props.apiAccessesInfoData.allowedAccesses.forEach((item) => {
                    //Caution: Do not remove setTimeout is used to create little delay or execute code block next event cycle to give click() proper execution time
                        setTimeout(() => {
                            let dualListBoxAvailable = document.getElementById('dualListBox-available');
                            dualListBoxAvailable.value = item;
                            let event = new Event('change');
                            dualListBoxAvailable.dispatchEvent(event);
                            document.getElementsByClassName('rdl-move-to-selected')[0].click();
                        });
                    });
                });
            }
            else
                displayErrorMessage("Internal Server Error");
        }

        //for fetching api info failure response
        if (prevProps.apiAccessesInfoData !== this.props.apiAccessesInfoData && this.props.apiAccessesInfoData.error) {
            displayErrorMessage(`Error occurred while fetching => ${(this.props.apiAccessesInfoData.error.response &&
                 this.props.apiAccessesInfoData.error.response.data) ? this.props.apiAccessesInfoData.error.response.data.message : "Something went wrong! Please try again."}`)
        }

        //for fetching access type success response
        if (prevProps.accessTypes !== this.props.accessTypes && !this.props.accessTypes.error) {
            let accessTypes = [];
            this.props.accessTypes.forEach(item => {
                accessTypes.push({ value: item, label: item })
            });
            this.setState({
                accessTypes: accessTypes
            });
        }

        //for fetching access types failure response
        if (prevProps.accessTypes !== this.props.accessTypes && this.props.accessTypes.error) {
            displayErrorMessage(`Error occurred while fetching access type => ${(this.props.accessTypes.error.response && this.props.accessTypes.error.response.data) ? this.props.accessTypes.error.response.data.message : "Something went wrong! Please try again."}`)
        }

        //for submit success response
        if (prevProps.apiAccessesSubmitData !== this.props.apiAccessesSubmitData && !this.props.apiAccessesSubmitData.error) {
            displaySuccessMessage("Submitted Successfully");
            setTimeout(() => {
            window.location.reload();},1000);
        }

        //for submit failure response
        if (prevProps.apiAccessesSubmitData !== this.props.apiAccessesSubmitData && this.props.apiAccessesSubmitData.error) {
            displayErrorMessage(`Error occurred while fetching => ${(this.props.apiAccessesSubmitData.error.response && this.props.apiAccessesSubmitData.error.response.data) ? this.props.apiAccessesSubmitData.error.response.data.message : "Something went wrong! Please try again."}`)
        }

     }

    handleCorporateChange = (selectedData) => {
        this.resetStates();
        this.setState({ selectedCorporate: selectedData});
    }

    handlePlatformChange = (selectedData) => {
        this.resetDualListBox();
        this.setState({ selectedPlatform: selectedData});
        if(selectedData && selectedData.label && selectedData.label != PLATFORM_RUBIX_KYC) {
            this.resetAccessType();
            let data = {
                platform: selectedData.label,
                allowedAccesses: this.state.allowedApis,
                corporateId: this.state.selectedCorporate.value
            };
            this.props.fetchApiAccessesInfo(data);
        }
        else
            this.props.fetchApiAccessTypes();
    }

    handleAccessTypeChange = (selectedData) => {
        this.resetDualListBox();
        this.setState({ selectedAccessType: selectedData});
        if(this.state.selectedPlatform.label && this.state.selectedPlatform.label == PLATFORM_RUBIX_KYC) {
            let data = {
                platform: this.state.selectedPlatform.label,
                allowedAccesses: this.state.allowedApis,
                corporateId: this.state.selectedCorporate.value,
                accessType: selectedData.label
            };
            this.props.fetchApiAccessesInfo(data);
        }
        else
            displayErrorMessage('Access type is only for RUBIX KYC.')
    }

    handleListBoxSelectionChange = (selectedData) => {
        this.setState({ allowedApis: selectedData })
    }

    submit = (e) => {
        e.preventDefault();

        //validating fields
        if(!this.state.selectedCorporate) {
            displayErrorMessage('Please select corporate!');
            return;
        }
        if(!this.state.selectedPlatform) {
            displayErrorMessage('Please select platform!');
            return;
        }
        if(this.state.selectedPlatform.label == PLATFORM_RUBIX_KYC && !this.state.selectedAccessType) {
            displayErrorMessage('Please select access type required for RUBIX_KYC!');
            return;
        }

        let data = {
            platform: this.state.selectedPlatform.label,
            allowedAccesses: this.state.allowedApis,
            corporateId: this.state.selectedCorporate.value,
            accessType: (this.state.selectedPlatform.label && this.state.selectedPlatform.label == PLATFORM_RUBIX_KYC  ?
                        this.state.selectedAccessType.label : null)
        };
        this.props.submitApiAccesses(data);
    }


    render() {
        
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">Manage API Access</h4>
                </div>
                <Card>
                    <CardBody >
                        <Row className="mb-3 align-items-center">
                        <Col sm={4}>
                            <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Corporate Name</span>
                        </Col>
                            <Col sm={10}>
                            <Select
                                value={this.state.selectedCorporate}
                                onChange={this.handleCorporateChange}
                                options={this.state.corporates}
                                isClearable={false}
                                required/>
                            </Col>
                        </Row>
                        <Row className="mb-3 align-items-center">
                            <Col sm="4"><span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Platform</span>
                            </Col>
                            <Col sm={6}>
                            <Select
                                isDisabled={!this.state.selectedCorporate}
                                value={this.state.selectedPlatform}
                                onChange={this.handlePlatformChange}
                                options={PLATFORMS}
                                isClearable={false}
                                required/>
                            </Col>
                        </Row>
                        <Row className="mb-3 align-items-center">
                            <Col sm="4"><span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Access Types</span>
                            </Col>
                            <Col sm={6}>
                            <Select
                                isDisabled={!(this.state.selectedCorporate && this.state.selectedPlatform && this.state.selectedPlatform.label == PLATFORM_RUBIX_KYC)}
                                value={this.state.selectedAccessType}
                                onChange={this.handleAccessTypeChange}
                                options={this.state.accessTypes}
                                isClearable={false}
                                required/>
                            </Col>
                        </Row>
                        <br/>
                        <Label className="h5 mb-3">Select Available Accesses</Label>
                        <Row>
                            <Col sm={14}>
                            <DualListBox id="dualListBox"
                                options={this.state.availableApis}
                                selected={this.state.allowedApis}
                                onChange={this.handleListBoxSelectionChange}
                                preserveSelectOrder
                            />
                            </Col>
                            
                        </Row>
                        <Row><Col sm={3}>
                                <Button type="submit" color="primary" className="justify-content-center mt-4" onClick={this.submit}>Submit</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    corporateNameList: state.cases.corporateNameList,
    apiAccessesInfoData: state.globalConfiguration.apiAccessesInfoData,
    apiAccessesSubmitData: state.globalConfiguration.apiAccessesSubmitData,
    accessTypes: state.globalConfiguration.accessTypes,
})

const mapDispatchToProps = (dispatch) => ({
    getCorporateName: () => { dispatch(getCorporateName()) },
    fetchApiAccessesInfo: (data) => { dispatch(fetchApiAccessesInfo(data)) },
    fetchApiAccessTypes: (data) => { dispatch(fetchApiAccessTypes(data)) },
    submitApiAccesses: (data) => { dispatch(submitApiAccesses(data)) }
});


export default connect(mapStateToProps, mapDispatchToProps)(ApiAccessManager);